import { AppRootState } from '../../../../../store/models/app-state.model';
import { FileMetadataModel } from '../../../../shared/models/file-metadata.model';

export const getFirmwareFileSelector = (
  state: AppRootState
): FileMetadataModel | null => state.firmware.firmwareFile;
